import styled from 'styled-components'

interface IBudgetCategoryFormStyledProps {}

export const BudgetCategoryFormStyled = styled.div<IBudgetCategoryFormStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
